import { useEffect, useState } from 'react'
import './CancelAppointment.scss'
import { ErrorModal, Loader, Modal, SuccessModal } from 'medere-ui-framework';
import { Button } from 'primereact/button';

import { useIntl } from 'react-intl';

import { cancelAppointment, getAppointmentInformationForCancel } from '../../services/AppointmentService';
import InfoCard from '../../components/InfoCard/InfoCard';

export default function CancelAppointment() {

  const [responseData,setResponseData]:any=useState(null);

  const [,setShowErrorModal]=useState(false);

  const intl = useIntl();

  const [showCannotCancelModal,setShowCannotCancelModal]=useState(false);
  const [showAppointmentCancelled,setShowAppointmentCancelled]=useState(false);
  const [showAppointmentCancelledProblem,setShowAppointmentCancelledProblem]=useState(false);

  const [showLoader,setShowLoader]=useState(false);
  const [siteLogo]=useState("");

  useEffect(()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const appID = urlParams.get('appID'); 
    const me = urlParams.get('me'); 

    if(appID && me){
      getAppointmentInformationForCancel(appID,me).then(res=>{
        if(res.status===200){
          if(res.data=="cannot cancel")
            setShowCannotCancelModal(true)
          else{
            setResponseData(res.data)
            setShowErrorModal(false);
          }
        }else{
          setShowErrorModal(true)
        }
      });
     
    }
    
  },[])

  function cancelThisAppointment(){
    setShowLoader(true)
    cancelAppointment(responseData.pcq).then(res=>{
      if(res.status==200){
        //se cancelo correctamente
        setShowLoader(false)
        setShowAppointmentCancelled(true);
      }else{
        //ocurrio un error en medere al cancelar el turno
        setShowLoader(false)
        setShowAppointmentCancelledProblem(true)
      }
    }).catch(()=>{setShowLoader(false)})
  }
  function closeWindow(){
      window.close()
  }

  return (
    <div className='flexible--column width-100 height-100 cancel-view-container viewContainer'>
        {(responseData && !showCannotCancelModal) && <div className='flexible--column cancel-container'>
        {siteLogo && <img style={{borderRadius:'8px',marginBottom:'16px',width:'100px',height:'100px'}} src={siteLogo} alt="logo" 
        className='logoSite' />}
          {showLoader && <Loader className="warningSpinner" size={24}/> }
          <div className='flexible-row content'>
            <h3 style={{marginBottom:'16px'}}>{intl.formatMessage({id:"AppointmentCancellation"})}</h3>
            
            <InfoCard textClassName={"textBold infoText"} icon="vaadin:doctor" label={intl.formatMessage({id:"Professional"})} text={responseData.professional}></InfoCard>
            { responseData.speciality!="" && <InfoCard textClassName={"textBold infoText"} icon="vaadin:stethoscope" label={intl.formatMessage({id:"Speciality"})} text={responseData.speciality}></InfoCard>}
            <InfoCard textClassName={"textBold infoText"} icon="vaadin:calendar" label={intl.formatMessage({id:"Date"})} text={intl.formatDate(responseData.date,{weekday:'long',hour:'2-digit',minute:'2-digit',day:'2-digit',month:'2-digit',year:'numeric'})}></InfoCard>
            
            <div style={{marginTop:'8px',justifyContent:'center',alignItems:'center'}} className='flexible--row'>
              <Button className='buttonMain' onClick={closeWindow}>{intl.formatMessage({id:"Back"})}</Button>
              <Button className='buttonMain' onClick={cancelThisAppointment}>
                {showLoader ? <Loader className="warningSpinner" size={24}/> : intl.formatMessage({id:"Yes"})+"," + intl.formatMessage({id:"Cancel"}) }
                </Button>
            </div>
          </div>
        </div>}
        <Modal visible={showCannotCancelModal} setVisible={setShowCannotCancelModal} header={intl.formatMessage({id:"Attention"})}
        onHideCustom={closeWindow} >
        {intl.formatMessage({id:"CannotCancelAppointment"})}
        </Modal>
        <SuccessModal visible={showAppointmentCancelled} setVisible={setShowAppointmentCancelled} header={intl.formatMessage({id:"AppointmentCancelled"})} onHide={closeWindow}>
        </SuccessModal>
        <ErrorModal visible={showAppointmentCancelledProblem} setVisible={setShowAppointmentCancelledProblem} header={intl.formatMessage({id:"AppointmentCancelledProblem"})}>
        </ErrorModal>
    </div>
  )
}
